import { useState, useEffect } from 'react';
import SvgMaze from '../components/SvgMaze';
import MazeWalker from '../components/MazeWalker';
import { generateMazeGrid } from '../utils/generateMaze';
import usePageTitle from '../hooks/usePageTitle';
import '../styles/maze.scss'

const Maze = () => {
  const [grid, setGrid] = useState([]);
  const [playerPos, setPlayerPos] = useState({ x: 0, y: 0 });

  const generateMaze = () => {
    setGrid(generateMazeGrid(20, 20));
    setPlayerPos({ x: 0, y: 0 }); 
  };

  useEffect(() => {
    generateMaze();
  }, []);

  usePageTitle('Maze Generated Game | Dochano');

  return (
    <section id="Maze">
      <div id="Intro">
        <h1>Maze Generator</h1>
      </div>
      
      <p className="indent">Sharing a quick Maze Game created with assistance of AI in 3 hours. Best used with Keyboard. This was a pet project to entice my son on the benefits of AI to assist in his goal of Game Development.</p>
      
      <button onClick={generateMaze} className="random-button">Regenerate Maze</button>
      
      {grid.length > 0 && (
        <div className="maze-container">
          <MazeWalker grid={grid} playerPos={playerPos} setPlayerPos={setPlayerPos} />
          <SvgMaze grid={grid} cellSize={30} playerPos={playerPos} />
        </div>
      )}
    </section>
  );
};

export default Maze;